<template>
  <section class="practice">
    <vue-snotify></vue-snotify>
    <div class="row">
      <aside class="col-md-3 col-sm-12 cus-sidebar">
        <practiceSidebar />
      </aside>
      <div v-if="isLoading" class="loader">
        <div class="wave-container">
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
          <div class="wave"></div>
        </div>
        <p>Loading...</p>
      </div>
      <div
        v-if="!isLoading"
        id="content"
        class="content focus-content dailyReport col-md-9 col-sm-12"
      >
        <div class="material-box bg-white">
          <div class="col-md-12 top-title">
            <h3>Focuses</h3>
          </div>
          <!-- end page-header -->
          <div class="col-md-12">
            <div
              class="section-container section-with-top-border patient_report"
            >
              <div class="inner_patient_report">
                <div class="row">
                  <div class="col-md-6 form-group rmPM">
                    <label
                      class="checkbox-inline"
                      style="display: flex; align-items: center"
                    >
                      <input
                        type="checkbox"
                        checked=""
                        v-model="allMembersResultValue"
                        name="roles"
                        style="margin-right: 5px"
                      />
                      Require all members to update their respective results:
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </label>
                  </div>
                  <div class="col-md-1">
                    <label class="checkbox-inline" style="margin-top: -28px">
                      <input
                        value="Submit"
                        class="btn btn-primary btn-blue m-t-20"
                        @click.prevent="allMembersResultUpdate()"
                        type="button"
                      />
                    </label>
                  </div>
                </div>
                <br />
                <form action="post" @submit.prevent="assignFocuses()">
                  <div class="row">
                    <div class="col-md-3 form-group">
                      <input
                        placeholder="Start Date"
                        class="form-control"
                        type="text"
                        onfocus="(this.type='date')"
                        onblur="(this.type='date')"
                        id="date"
                        v-model="focusData.startDate"
                        required
                      />
                      <!-- <input type="date" class="form-control" v-model="focusData.startDate"  required> -->
                    </div>
                    <div class="col-md-3 form-group">
                      <select
                        class="form-control custom-select"
                        v-model="focusData.UserID"
                        required
                      >
                        <option value="">Select User</option>
                        <option
                          :value="user.UserID"
                          v-for="(user, i) in allUsers"
                          :key="i"
                        >
                          {{ user.FirstName }} {{ user.LastName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 form-group">
                      <select
                        class="form-control custom-select"
                        v-model="focusData.FocusCode"
                        required
                      >
                        <option value="">Select Focus</option>
                        <option
                          :value="focus.FocusCode"
                          v-for="(focus, i) in allFoucs"
                          :key="i"
                        >
                          {{ focus.FocusName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 text-right form-group">
                      <input
                        value="Submit"
                        class="btn btn-primary btn-blue m-t-20"
                        type="submit"
                      />
                    </div>
                  </div>
                </form>
                <br />
                <div class="">
                  <br />
                  <div class="table-responsive">
                    <table
                      class="table table-bordered table-td-valign-middle comnTbl"
                    >
                      <thead>
                        <tr class="bg-drk-blue">
                          <th class="text-center">Name</th>
                          <th class="text-center">Current Focuses</th>
                          <th class="text-center">Status</th>
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <template v-for="(user, index) in userFocuses">
                          <tr :key="user.UserID"
                            :class="{
                              toggle: isUserDetailsVisible(user.UserID),
                            }"
                          >
                            <td class="text-center">
                              {{ user.FirstName }} {{ user.LastName }}
                            </td>
                            <td class="text-center">
                              {{ user.assignedFocuses }}
                            </td>
                            <td class="text-center">{{ user.Status }}</td>

                            <td class="text-center">
                              <b-button
                                @click="toggleClass(user.UserID, user.LastName, user.FirstName)"
                                class="btn btn-primary f-btn btn-blue btn-xs btn-rounded p-l-10 p-r-10"
                                ><i class="fa fa-gear"></i> Edit</b-button
                              >
                            </td>
                          </tr>

                          <tr
                            accordion="adjust"
                            :key="`i${index}`"
                            class="tr-none"
                            :class="{
                              toggle: isUserDetailsVisible(user.UserID),
                            }"
                          >
                            <td colspan="5">
                              <table style="width: 100%">
                                <tr v-if="user.focuses.length > 0">
                                  <td colspan="4">
                                    <div class="table-responsive">
                                      <table class="table table-sm">
                                        <thead>
                                          <tr>
                                            <th>#</th>
                                            <th>Focus</th>
                                            <th>Start Date</th>
                                            <th>Remove Focus</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <template
                                            v-for="(focus, i) in user.focuses"
                                          >
                                            <tr
                                              :key="i"
                                              v-if="focus.ActiveStatus != 0"
                                              style="
                                                background-color: #636a71;
                                                color: #eceeef;
                                              "
                                            >
                                              <th scope="row">{{ i }}</th>
                                              <th scope="row">
                                                {{ focus.FocusName }}
                                              </th>
                                              <th scope="row">
                                                {{
                                                  formateDate(
                                                    focus.FocusStartDate
                                                  )
                                                }}
                                              </th>
                                              <th scope="row">
                                                <a
                                                  @click.prevent="
                                                    deleteAssignFocus(focus.ID, focus.FocusName)
                                                  "
                                                  class="btn btn-danger btn-xs btn-rounded p-l-10 p-r-10"
                                                  ><i class="fa fa-trash-o"></i>
                                                  Remove</a
                                                >
                                              </th>
                                            </tr>
                                          </template>
                                        </tbody>
                                      </table>
                                    </div>
                                  </td>
                                </tr>
                                <tr v-else>
                                  <td colspan="5">No Record Found.</td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import practiceSidebar from "../components/Sidebar.vue";
import userAPI from "../../userApi";
import moment from "moment";

export default {
  name: "focuses",
  components: {
    practiceSidebar,
  },

  data() {
    return {
      isLoading: false,
      focusData: {
        UserID: "",
        FocusCode: "",
        startDate: "",
        PracticeID: "",
      },
      allMembersResultValue: "",
      loginUser: {},
      userFocuses: {},
      allUsers: {},
      allFoucs: {},
      isToggle: false,
      userToggleStates: {},
      name:""
    };
  },

  methods: {
    formateDate(date) {
      return moment(date).format("MM-DD-Y");
    },
    assignFocuses() {
      this.focusData.PracticeID = this.loginUser.PracticeID;
      userAPI.assignFocuses(
        this.focusData,
        (res) => {
          this.$showNotification(res.data, "success");
          this.getFocusesWithUser();
        },
        (err) => {
          if (err.response.status == 409) {
            this.$showNotification(err.response.data, "error");
          } else {
            this.$showNotification({ message: "System Error" }, "error");
          }
        }
      );
    },
    allMembersResult() {
      userAPI.allMembersResult(
        { PracticeID: this.loginUser.PracticeID },
        (res) => {
          this.allMembersResultValue = res.data.result == 1 ? true : false;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    allMembersResultUpdate() {
      userAPI.allMembersResultUpdate(
        {
          PracticeID: this.loginUser.PracticeID,
          allMembersResultValue: this.allMembersResultValue,
        },
        (res) => {
          this.$showNotification({ message: "Update Sussessfully" }, "success");
        },
        (err) => {
          this.$showNotification({ message: "System Error" }, "error");
        }
      );
    },
    getAllFoucs() {
      userAPI.getAllFoucs(
        (res) => {
          this.allFoucs = res.data.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getUsersByPractice() {
      userAPI.getUsersByPractice(
        { practiceID: this.loginUser.PracticeID },
        (res) => {
          this.allUsers = res.data.data;
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getFocusesWithUser() {
      this.isLoading = true;
      userAPI.getFocusesWithUser(
        { PracticeID: this.loginUser.PracticeID },
        (res) => {
          this.userFocuses = res.data.data;
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
        }
      );
    },
    deleteAssignFocus(id, name) { 
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete this focus!",
      }).then((result) => {
        if (result.value) {
          let data = {
            id: id,
          };
          userAPI.deleteAssignFocus(
            { id },
            (res) => {  
              this.$showNotification(
                { message: `Your ${name} Focus has been removed from ${this.name}` },
                "success"
              );
              this.getFocusesWithUser();
            },
            (err) => {
              this.$showNotification({ message: "System Error" }, "error");
              console.log(err);
            }
          );
        }
      });
      // this.$router.push({name: 'edit_Vendor', params: {user: member}});
    },

    toggleClass(userId, firstName, lastName) {
      this.name = firstName +' '+ lastName;
      this.$set(this.userToggleStates, userId, !this.userToggleStates[userId]);
    },
    isUserDetailsVisible(userId) {
      return this.userToggleStates[userId];
    },
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user;

    if (user.Status == "DC" || user.Status == "CA") {
      this.$router.push({ name: "user_dashboard" });
    }

    this.getFocusesWithUser();
    this.getUsersByPractice();
    this.getAllFoucs();
    this.allMembersResult();
  },
};
</script>